import React from 'react';

// components
import { Link, NavLink, Redirect } from 'react-router-dom';
import Header from "../../components/Header";
import SystemErrorMessage from '../../components/SystemErrorMessage';
import AuthService from '../../services/AuthService';
import MembersApi from '../../services/portal-api/MembersApi';
// services
import withAuth from "../../services/withAuth";
import ApiStatSection from './components/ApiStatSection';
import JobSection from "./components/JobSection";
import OverrideSection from './components/OverrideSection';
import swal from 'sweetalert';
import NotFound from '../NotFound';
import RestartQueue from './components/components/RestartQueue';
import NavigationBar from '../Navigation';

class AdminTools extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null,
            viewSlug: null,
            jobsection: this.queryString() == 'job' ? true : false,
            apisection: this.queryString() == 'api' ? true : false,
            ovrdsection: this.queryString() == 'ovrd' ? true : false,
            msg: null,
            restart: false,
        }

    }

    componentDidMount() {
        document.title = 'Admin Tools - duskPortal';
        document.body.className = 'page--green';
        MembersApi.getCountry((result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }
        });// just call to check token expiry

        if (this.queryString() == null) {
            this.setState({
                msg: null,
                error: null,
                jobsection: true,
                apisection: false,
                ovrdsection: false,
                restart: false
            }, () => {
                console.log("queryString", this.queryString());
            });
        }
    }

    setMessage = (msg) => {
        this.setState({
            msg: msg
        }, () => {
            console.log("msg state changed from child component");
        });
    }

    queryString = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('sec');
    }

    _sessionLoadOut = (response) => {
        // Check for auth
        if (response.status === 401) {
            this.props.sessionExpired();
            this.setState({
                isLoading: false,
            });
            return;
        } else {
            // alert("Something went wrong");
            swal("Something went wrong", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }
    }

    loadSection = (event) => {
        let section = event.target.getAttribute("data-id");
        if (section == 'api') {
            this.props.history.push('/admintools');
        }
        switch (section) {
            case 'job':
                this.setState({
                    msg: null,
                    error: null,
                    jobsection: true,
                    apisection: false,
                    ovrdsection: false,
                    restart: false
                });
                break;
            case 'api':
                this.setState({
                    msg: null,
                    error: null,
                    ovrdsection: false,
                    jobsection: false,
                    apisection: true,
                    restart: false
                });
                break;
            case 'ovrd':
                this.setState({
                    msg: null,
                    error: null,
                    jobsection: false,
                    apisection: false,
                    ovrdsection: true,
                    restart: false
                });
                break;
        }
    }

    restartQueue = (event) => {
        this.setState({ restart: true }, () => {
            MembersApi.restartQ((result) => {
                if (result.success) {
                    if (result.json.success) {
                        this.setState({
                            msg: "Queue restarted successfully",
                            error: null,
                            restart: false
                        });
                    } else {
                        this.setState({
                            msg: null,
                            error: "Restart failed :" + result.json.error,
                            restart: false
                        });
                    }
                } else {
                    this._sessionLoadOut(result);
                }
            });
        });
    }

    render() {
        let msg = this.state.msg;
        let queue_status = this.state.restart ? "Restarting" : "Restart Queue";
        return (
        
            <div>
                <Header />
                <main className="content" role="main">
                    <div className="container container--wide padding--40">
                        <div className="info-wrap col gutter--40 margin--10--bot">
                            <div className="col">
                                <NavigationBar
                                    loadSection={this.loadSection} 
                                />
                            </div>
                            <div className="info-wrap col gutter--40 margin--30--bot">
                                <div className="col">
                                    {this.state.error !== null &&
                                        <div>
                                            <SystemErrorMessage message={this.state.error} />
                                        </div>
                                    }
                                    {this.state.error == null && this.state.msg !== null && <div className="alert alert--outline alert--success text--center margin--10--bot">{this.state.msg}</div>}
                                </div>
                            </div>

                            {AuthService.can('jobs') && this.state.jobsection && <JobSection sessionLoadOut={this._sessionLoadOut}></JobSection>}
                            {AuthService.can('API logs') && this.state.apisection && <ApiStatSection sessionLoadOut={this._sessionLoadOut}></ApiStatSection>}
                            {AuthService.can('Settings') && this.state.ovrdsection && <OverrideSection sessionLoadOut={this._sessionLoadOut}></OverrideSection>}
                        </div>
                        <div className="scrollToTop" title="scroll to top" style={{ position: "absolute", bottom: 30, right: 30, cursor: 'pointer', borderRadius: 34, boxShadow: '0px 1px 7px #444', width: 40, height: 40, transform: 'rotateZ(180deg)', padding: 8, textAlign: 'center' }} onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth', }); }}>V</div>
                    </div>
                </main>
            </div>

        )
    }
}

export default withAuth(AdminTools);